/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/DirektTeaser/theme';

export const DirektTeaserTheme = theme;
